import {getCSRFToken, setCSRFToken} from './CSRFToken';
import {CSRFToken, XSRFToken} from '../../@types/services/CSRFProtection';
import {getXSRFToken, setXSRFToken} from './XSRFToken';
import {ICSRFManager} from '../../@interfaces/services/CSRFManager/ICSRFManager';

export * from './CSRFToken';
export * from './XSRFToken';

export class CSRFManager implements ICSRFManager {
	get token(): CSRFToken | XSRFToken | string {
		return getCSRFToken() || getXSRFToken() || '';
	}

	get CSRFToken(): XSRFToken {
		return getCSRFToken() || '';
	}

	set CSRFToken(token: XSRFToken) {
		setCSRFToken(token);
	}

	get XSRFToken(): XSRFToken {
		return getXSRFToken() || '';
	}

	set XSRFToken(token: XSRFToken) {
		setXSRFToken(token);
	}
}
